var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--jawn"},[_c('div',{staticClass:"spinner-inner",style:(_vm.styles)},[_c('div',{staticClass:"jawn",style:(_vm.innerStyles)})])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47ba83ac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-loading-spinner/src/components/Jawn.vue
// module id = t8rX
// module chunks = 0